export var capitalizeFirstLetter = function (input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
};
export var isEmpty = function (input) {
    return input === null || input === undefined || input.trim().length === 0;
};
